<template>
  <div>
    <div class="login-container">
      <h1 class="mb-4">Login</h1>
      <form @submit.prevent="submitLogin()">
        <div class="form-group">
          <label>Username</label>
          <input class="form-control" type="text" v-model="login.username" required>
        </div>
        <div class="form-group">
          <label>Password</label>
          <input class="form-control" type="password" v-model="login.password" required>
        </div>
        <p class="login-error">{{ loginError }}</p>
        <button class="btn btn-outline-primary btn-block mt-4" type="submit">Send</button>
      </form>
    </div>
  </div>
</template>

<style>
.login-container {
  width:600px;
  margin:auto;
  padding:30px;
}
.login-error {
  font-weight:700;
  color:red;
}
</style>

<script>
export default {
  name: "Login",
  data() {
    return {
      login: {
        username: "",
        password: ""
      },
      loginError: ""
    }
  },
  methods: {
    submitLogin() {
      if(!this.login.username || !this.login.password) return this.loginError = "Fields missing";
      if(!this.loginError) {
        this.$store.dispatch("API_CALL", { method: "post", url: "/auth/login", data: this.login }).then((res) => {
          localStorage.adminToken = res.data.token;
          this.$router.push("/admin");
        }).catch((err) => {
          this.loginError = err.response.data.message;
        })
      }
    }
  }
}
</script>
